import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLoaderComponent } from './page-loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from '../../shared/shared.module';
import { IconsModule } from '../../icons/icons.module';

@NgModule({
  declarations: [
    PageLoaderComponent
  ],
  exports: [
      PageLoaderComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    SharedModule,
    IconsModule
  ]
})
export class PageLoaderModule { }
